export const IntegrationItem = {
  extends: ['Flex', 'Link'],
  position: 'relative',
  href: '/playground',
  fontWeight: 'bold',
  overflow: 'hidden',
  flexDirection: 'column',
  width: '100%',
  height: 'F2',
  padding: '0 Z 0 A2',
  round: 'radiusControl',
  // Border habit removed (design-direction.md §8) — the poster image IS the
  // tile's own fill, and IntegrationsList's `gap: 'C1'` grid already gives
  // every tile generous whitespace separation; no stroke needed.
  background: ({ state }) => `url(${state.poster}) center center no-repeat`,
  backgroundSize: 'cover',
  ':after, :before': {
    content: '""',
    position: 'absolute',
    inset: '0 0 0 0',
    transition: 'B defaultBezier',
    transitionProperty: 'opacity',
    background: 'shadow-overlay',
    zIndex: 1
  },
  Title: {
    // Reviewed (fixed-colour sweep): kept — this label floats over an
    // arbitrary poster image (`background: url(state.poster)` above), so its
    // backing plate (`gray1.65`) must stay a fixed dark scrim regardless of
    // app theme; the paired text stays fixed to match (case 1: badge over
    // arbitrary imagery).
    color: 'gray8',
    fontWeight: 400,
    position: 'absolute',
    inset: 'auto 0 0 0',
    padding: 'Z A Z2',
    background: 'gray1.65',
    boxShadow: '0 0 35px gray1',
    zIndex: 2,
    text: '{{ title }}'
  }
}
